import { Link } from '@tanstack/react-router';

import { Button, ErrorState } from '@keboola/design';

/**
 * What an address matching no route renders.
 *
 * ⚠️ Not cosmetic. TanStack's built-in fallback is the bare string "Not Found" in the top-left corner
 * of an otherwise empty document — no chrome, no way back, and against the dark surface it is close to
 * invisible. A public site that a search engine or an old bookmark can land on needs a real page.
 */
export function NotFoundPage() {
  return (
    <div className="tw:flex tw:min-h-svh tw:items-center tw:justify-center tw:p-6">
      <ErrorState>
        <ErrorState.Title as="h1">Page not found</ErrorState.Title>
        <ErrorState.Description>
          The address does not match anything here. It may have moved, or the link may be out of
          date.
        </ErrorState.Description>
        <ErrorState.Actions>
          <Button asChild variant="secondary">
            <Link to="/components">Browse components</Link>
          </Button>
        </ErrorState.Actions>
      </ErrorState>
    </div>
  );
}
